// TODO ISO 27001: integrar con servicio centralizado de logs (Datadog/Sentry/etc)
// para auditoría persistente en producción.

const isDev = process.env.NODE_ENV !== "production";

export function maskSecret(value) {
    if (!value || typeof value !== "string") return "[empty]";
    if (value.length <= 8) return "[short-secret]";
    return value.slice(0, 6) + "...";
}

export function sanitizeUrl(url) {
    try {
        const u = typeof url === "string" ? new URL(url) : url;
        const sensitiveParams = ["ticket", "token", "ultimoEventoId", "key", "secret"];
        const presentSensitive = sensitiveParams.filter((k) => u.searchParams.has(k));
        const tag = presentSensitive.length > 0 ? ` [params: ${presentSensitive.join(",")}]` : "";
        return `${u.origin}${u.pathname}${tag}`;
    } catch {
        return "[invalid-url]";
    }
}

export const log = {
    debug: (...args) => { if (isDev) console.log(...args); },
    info:  (...args) => { if (isDev) console.log(...args); },
    warn:  (...args) => { console.warn(...args); },
    error: (...args) => { console.error(...args); },
};
